function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.64027 7.22608C4.72045 7.23733 4.82342 7.24296 4.93825 7.24296C5.45338 7.24296 5.89442 7.12046 6.19176 6.84702C6.4211 6.63515 6.54715 6.32265 6.54715 5.95452C6.54715 5.5864 6.38132 5.27421 6.13466 5.08421C5.87742 4.88358 5.49347 4.78296 4.95557 4.78296C4.4228 4.78296 4.04495 4.8164 3.77615 4.86108V8.57077H4.64059V7.22608H4.64027ZM4.64027 5.45765C4.70313 5.44077 4.82342 5.42421 5.00112 5.42421C5.43606 5.42421 5.6824 5.63077 5.6824 5.9764C5.6824 6.3614 5.39629 6.59015 4.93215 6.59015C4.80642 6.59015 4.715 6.58483 4.64027 6.56796V5.45765Z",
  fill: "#FF812F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.81836 8.12415C10.1904 7.81728 10.4596 7.32103 10.4596 6.60103C10.4596 5.93728 10.2078 5.47447 9.80682 5.18447C9.43474 4.91103 8.9597 4.78259 8.22678 4.78259C7.78574 4.78259 7.36748 4.81041 7.04736 4.86072V8.55353C7.26451 8.58134 7.58527 8.60947 8.03753 8.60947C8.79291 8.60947 9.41165 8.45322 9.81836 8.12415ZM7.92302 5.46884C7.99712 5.45228 8.12317 5.4354 8.31787 5.4354C9.06812 5.4354 9.53738 5.84822 9.53193 6.62916C9.53193 7.52728 9.01616 7.95134 8.22646 7.94572C8.1174 7.94572 7.99712 7.94572 7.92302 7.92884V5.46884Z",
  fill: "#FF812F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8531 7.05904H13.2387V6.36716H11.8531V5.5081H13.3356V4.81091H10.9771V8.5706H11.8531V7.05904Z",
  fill: "#FF812F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.36685 20H14.6332C15.9402 20 17 18.9675 17 17.6941V2.30594C17 1.0325 15.9402 0 14.6332 0H2.36685C1.05977 0 0 1.0325 0 2.30594V17.6941C0 18.9675 1.05977 20 2.36685 20ZM1.28302 2.30594C1.28302 1.72375 1.76928 1.25 2.36685 1.25H14.6332C15.2307 1.25 15.717 1.72375 15.717 2.30594V17.6941C15.717 18.2762 15.2307 18.75 14.6332 18.75H2.36685C1.76928 18.75 1.28302 18.2762 1.28302 17.6941V2.30594Z",
  fill: "#FF812F"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9527 12.0935H3.04709V13.3435H13.9527V12.0935Z",
  fill: "#FF812F"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9527 13.9384H3.04709V15.1884H13.9527V13.9384Z",
  fill: "#FF812F"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9527 15.7828H3.04709V17.0328H13.9527V15.7828Z",
  fill: "#FF812F"
});

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.f5b62cd9.svg";
export { ForwardRef as ReactComponent };